'use strict';

const { initial } = require('lodash'); //eslint-disable-line
var utils = require('../util/utils');
var ProductTile = require('./productTile');

var productTile;

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    datePickerAction();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('.refinement-item-accordion').removeClass('collapsed').attr('aria-expanded', 'true');
        activeDiv.find('.refinement-filters-container').addClass('show');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.search-empty-div'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    let resetBtn = $results.find('button.reset.btn');
    if (resetBtn.length > 0) {
        if (resetBtn.hasClass('disabled')) {
            $('button.reset.btn').addClass('disabled').blur();
        } else {
            $('button.reset.btn').removeClass('disabled').blur();
        }
    } else if ($results.find('.search-empty-div').length > 0) {
        $('button.reset.btn').removeClass('disabled').blur();
    }
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function datePickerAction() {
    var url = $('.permalink').val();
    var urlParams = utils.getQueryStringParams(url);
    var urlParamsStringify = JSON.stringify(urlParams);

    function handleDateChange(e) {
        let dateStartValue = $('.js-filters-date-start').datepicker('getDates');
        let dateEndValue = $('.js-filters-date-end').datepicker('getDates');
        if (!dateStartValue.length || !dateEndValue.length) {
            return true;
        }
        e.preventDefault();
        e.stopPropagation();
        var startDate = new Date(dateStartValue);
        var endDate = new Date(dateEndValue);
        var datesString = '';
        var datesStringArray = [];
        for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
            var currentDay = new Date(date);
            var yyyy = currentDay.getFullYear();
            var mm = currentDay.getMonth() + 1;
            var dd = currentDay.getDate();
            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;
            var formattedToday = dd + '/' + mm + '/' + yyyy;
            datesStringArray.push(currentDay);
            if (currentDay.toDateString() !== endDate.toDateString()) {
                formattedToday += '|';
            }
            datesString += formattedToday;
        }
        var refinementUrlCurrent = $('.date-container').find('.current-page-url').val();
        var countOfIncludes = urlParamsStringify.match(/prefn/g || []) ? urlParamsStringify.match(/prefn/g || []).length + 1 : 1;

        urlParams['prefn' + countOfIncludes] = 'startDateStr';
        urlParams['prefv' + countOfIncludes] = datesString;
        for (const [key, value] of Object.entries(urlParams)) {
            if (value && key !== 'start' && key !== 'sz' && key !== 'lang') {
                refinementUrlCurrent = utils.appendParamToURL(refinementUrlCurrent, key, value);
            }
        }
        $.ajax({
            url: refinementUrlCurrent,
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: refinementUrlCurrent
            },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });

        return true;
    }

    let dateFormat = 'dd/mm/yyyy';
    let from = $('input.js-filters-date-start')
        .datepicker({
            language: 'he',
            autoclose: true,
            format: dateFormat
        })
        .on('change', function (e) {
            to.datepicker('setStartDate', getDate(this, from));
            handleDateChange(e);
        });
    let to = $('input.js-filters-date-end').datepicker({
        language: 'he',
        autoclose: true,
        format: dateFormat
    })
        .on('change', function (e) {
            from.datepicker('setEndDate', getDate(this, to));
            handleDateChange(e);
        });

    function getDate(element) {
        var date;
        try {
            let dateArr = element.value.split('/');
            date = new Date(dateArr[2], dateArr[1] - 1, dateArr[0]);
        } catch (error) {
            date = null;
        }

        return date;
    }
}

let closeAllOpenedRefinement = function (excludedClass) {
    let $openedRefinements = $('.refinement');
    if (excludedClass) {
        $openedRefinements = $openedRefinements.not('.' + excludedClass);
    }
    $openedRefinements.find('div[type=button]').addClass('collapsed').attr('aria-expanded', false);
    $openedRefinements.find('.refinement-filters-container').removeClass('show');
    $openedRefinements.removeClass('active');
};

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('body, html').addClass('menu-open');
            $('.refinement-bar .close').focus();
        });

        $(document).on('click', function () {
            closeAllOpenedRefinement();
        });
        $('div.selectric').on('click', function () {
            closeAllOpenedRefinement();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .close-another, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('body, html').removeClass('menu-open');
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('body, html').removeClass('menu-open');
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    productTile.initializeTiles();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .reset-container button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                var attributeId = '#' + $(this).find('span').last().attr('id');
                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                        closeAllOpenedRefinement();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    initialize: function () {
        productTile = new ProductTile();
    },

    datePickerAction: datePickerAction
};
